module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-page', {
    staticClass: "l-content l-keyMoment"
  }, [_c('custom-toolbar', {
    attrs: {
      "backLabel": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("Mes moments-clés")))]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "timeLine"
  }, _vm._l((_vm.key_moments), function(key_moment, index) {
    return _c('div', {
      key: index,
      staticClass: "moment",
      class: [key_moment.sav_fk_taskStatus == 3 ? 'checked' : '', key_moment.sav_date == _vm.today_label ? 'today' : '']
    }, [(key_moment.sav_date != _vm.today_label) ? _c('div', {
      staticClass: "infos"
    }, [_c('div', {
      staticClass: "picto"
    }, [_c('i', {
      class: [key_moment.sav_fk_taskStatus == 3 ? 'fas fa-check' : 'far fa-calendar-check', key_moment.sav_date == null ? 'fas fa-times' : '']
    })]), _vm._v(" "), _c('div', {
      staticClass: "dateHour"
    }, [_vm._v("\n            " + _vm._s(key_moment.sav_date !== null ? _vm.moment(key_moment.sav_date).format('DD/MM/YYYY') : _vm.$t('Indéterminée')) + "\n            "), _c('br'), _vm._v("\n            " + _vm._s(key_moment.sav_hourFrom) + "\n          ")])]) : _vm._e(), _vm._v(" "), (key_moment.sav_date == _vm.today_label) ? _c('div', {
      staticClass: "infos"
    }, [_c('div', {
      staticClass: "picto"
    }, [_c('i', {
      staticClass: "far fa-calendar-check"
    })]), _vm._v(" "), _c('div', {
      staticClass: "dateHour"
    }, [_vm._v("\n            " + _vm._s(_vm.$t(_vm.today_label)) + "\n          ")])]) : _vm._e(), _vm._v(" "), (key_moment.sav_date != _vm.today_label) ? _c('div', {
      staticClass: "descriptionInfo"
    }, [_c('div', {
      staticClass: "description"
    }, [_vm._v("\n            " + _vm._s(_vm.$t(key_moment.sav_name)) + "\n          ")])]) : _vm._e()])
  }), 0)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11558958","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/KeyMoments.vue
// module id = 192
// module chunks = 0